// Real collection links remain usable when JavaScript or the network is unavailable.
if (!window.lnkblissCollectionNavigation) {
  window.lnkblissCollectionNavigation = true;
  const stickyHeader = document.querySelector('header-component');
  const stickyHeaderSection = stickyHeader?.closest('.header-section');
  if (stickyHeaderSection) {
    const syncStickyOffset = () => {
      const stickyTop = Number.parseFloat(getComputedStyle(stickyHeaderSection).top);
      const height = stickyHeaderSection.getBoundingClientRect().height;
      const offset = Math.max(0, height + (Number.isFinite(stickyTop) ? stickyTop : 0));
      document.documentElement.style.setProperty('--lnk-collection-sticky-top', offset + 'px');
    };
    syncStickyOffset();
    if ('ResizeObserver' in window) {
      const headerObserver = new ResizeObserver(syncStickyOffset);
      headerObserver.observe(stickyHeaderSection);
    }
    window.addEventListener('resize', syncStickyOffset, { passive: true });
    window.addEventListener('pageshow', syncStickyOffset);
  }
  let activeRequest;
  const isCollectionPath = (pathname) => /\/collections\/[^/]+\/?$/.test(pathname);
  function revealActiveTab() {
    const tab = document.querySelector('[data-collection-tabs] [aria-current="page"]');
    const nav = tab?.closest('[data-collection-tabs]');
    if (nav && tab) {
      nav.scrollLeft += tab.getBoundingClientRect().left - nav.getBoundingClientRect().left - (nav.clientWidth - tab.clientWidth) / 2;
    }
  }
  revealActiveTab();
  async function navigate(url, push = true) {
    activeRequest?.abort();
    const controller = new AbortController();
    activeRequest = controller;
    const main = document.getElementById('MainContent');
    if (!main) { location.assign(url); return; }
    main.setAttribute('aria-busy', 'true');
    const status = main.querySelector('[data-collection-status]');
    if (status) status.textContent = status.dataset.loading;
    try {
      const fetchUrl = new URL(url);
      if (window.Shopify?.theme?.role !== 'main' && window.Shopify?.theme?.id) {
        fetchUrl.searchParams.set('preview_theme_id', window.Shopify.theme.id);
      }
      const response = await fetch(fetchUrl, { signal: controller.signal });
      if (!response.ok) throw new Error('Collection unavailable');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      // Parsed scripts are inert, and head styles are outside MainContent. A new
      // template dependency requires a document navigation to initialize safely.
      const dependencySelector = 'script[src], link[rel="stylesheet"][href]';
      const dependencyKey = (node, base) => `${node.tagName}:${new URL(node.getAttribute(node.tagName === 'SCRIPT' ? 'src' : 'href'), base).href}`;
      const loadedDependencies = new Set(Array.from(document.querySelectorAll(dependencySelector), (node) => dependencyKey(node, location.href)));
      const needsNewDependency = Array.from(page.querySelectorAll(dependencySelector)).some((node) => !loadedDependencies.has(dependencyKey(node, response.url || fetchUrl.href)));
      if (controller.signal.aborted || activeRequest !== controller) return;
      if (needsNewDependency) { location.assign(url); return; }
      const next = page.getElementById('MainContent');
      if (!next?.querySelector('[data-collection-tabs][data-collection-ajax]') || !next.querySelector('results-list')) throw new Error('Invalid collection');
      if (controller.signal.aborted || activeRequest !== controller) return;
      if (push) history.pushState({ collectionTabs: true }, '', url);
      // Shopify may emit section styles in the document head. Bring these scoped
      // style owners with the new section tree; styles already inside MainContent travel naturally.
      for (const style of page.querySelectorAll('style[data-section-stylesheet]')) {
        if (!next.contains(style)) next.prepend(style.cloneNode(true));
      }
      main.replaceChildren(...next.childNodes);
      document.title = page.title;
      const canonical = document.querySelector('link[rel="canonical"]');
      const nextCanonical = page.querySelector('link[rel="canonical"]');
      if (canonical && nextCanonical) canonical.href = nextCanonical.href;
      main.querySelector('[data-collection-tabs] [aria-current="page"]')?.focus({ preventScroll: true });
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (controller.signal.aborted || activeRequest && activeRequest !== controller) return;
        revealActiveTab();
        const nav = main.querySelector('[data-collection-tabs]');
        if (nav) {
          const container = nav.closest('.sq-collection-sticky-tabs') || nav;
          const stickyTop = Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--lnk-collection-sticky-top')) || 0;
          window.scrollTo({ top: Math.max(0, window.scrollY + container.getBoundingClientRect().top - stickyTop), behavior: 'instant' });
        }
      }));
      const newStatus = main.querySelector('[data-collection-status]');
      if (newStatus) newStatus.textContent = newStatus.dataset.loaded;
    } catch (error) {
      if (!controller.signal.aborted && activeRequest === controller && error.name !== 'AbortError') location.assign(url);
    } finally {
      if (activeRequest === controller) { main.removeAttribute('aria-busy'); activeRequest = null; }
    }
  }
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-collection-tabs][data-collection-ajax] a');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href);
    if (link.target && link.target !== '_self' || link.hasAttribute('download')) return;
    if (!document.querySelector('#MainContent results-list') || url.origin !== location.origin || !isCollectionPath(url.pathname)) return;
    event.preventDefault();
    if (link.hasAttribute('aria-current') && !activeRequest) return;
    navigate(url);
  });
  window.addEventListener('popstate', () => {
    if (document.querySelector('[data-collection-tabs][data-collection-ajax]')) {
      if (isCollectionPath(location.pathname)) navigate(new URL(location.href), false);
      else location.reload();
    }
  });
}
